import { render } from "./RatingIcon.vue?vue&type=template&id=38476b7c"
import script from "./RatingIcon.vue?vue&type=script&lang=js"
export * from "./RatingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__